import { SchemaType } from "@redotech/redo-flows-common/schemas/schemas";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const listPreviewEvents = {
  name: "listPreviewEvents" as const,
  input: z.object({
    /** The event type (flow schema) — routes to the matching preview provider. */
    eventType: createEnum(SchemaType, { enumName: "SchemaType" }),
    /** The specific event to pull recent examples of, e.g. "okendo_review_created". */
    eventName: z.string(),
    limit: z.number().int().positive().max(10).optional(),
  }),
  output: z.array(
    z.object({
      eventId: z.string(),
      eventName: z.string(),
      timestamp: z.date(),
      recipient: z.object({
        email: z.string(),
        firstName: z.string().optional(),
        lastName: z.string().optional(),
        redoCustomerId: z.string().optional(),
      }),
      /** The event's own key/values, shown as the payload in the preview sidebar. */
      properties: z.record(z.string(), z.unknown()),
    }),
  ),
};

export type PreviewEventListItem = z.infer<
  typeof listPreviewEvents.output
>[number];
